import { useCallback } from "react";

/**
 * Handles the click event for the arrow icon.
 * Unfortunately, `DhlSwitch` input value is not mapped to the one in Redux store.
 * We need to mimic the click event. Dispatching Redux action switches sections but is not reflected in input value.
 *
 * @param {React.RefObject<HTMLDhlSwitchElement>} switchRef Reference to the switch button that toggles the origin and destination sections.
 */
export const useOnArrowClick = (switchRef) => {
  const toggle = useCallback(async () => {
    const input = await switchRef.current.getInputElement();
    input.click();
  }, [switchRef]);

  return useCallback(
    (event) => {
      event.preventDefault();
      toggle().catch(console.error); // eslint-disable-line no-console
    },
    [switchRef]
  );
};
